const HTMLCode = (props: { children: string }) => <code data-component="code">{props.children}</code>;

export default HTMLCode;
